
import { reactive, computed, onBeforeMount } from 'vue'

const definition = reactive( {
    dev: false,
    dev_view: false,
    title: 'Produktberater für glückliche Haare',
    action: 'https://docs.google.com/forms/d/e/1FAIpQLSdo13K3aj50yy8G9TnSwA9Ulpp26cLlnp7wWnNZt9xpEvvOww/formResponse',
    pages: [

        {
            // title: "Los geht's",
            title: "Produktberater",
            description: 'Du weißt nicht, welche unserer Produkte am besten zu Dir passen? Beantworte einfach hier einige Fragen über Deinen Haartyp und Du erhältst innerhalb weniger Stunden eine individuelle und ausführliche Beratung von unserem Friseurteam per E-Mail :-)',
        },

        {
            title: 'Haartyp',
            description: 'Zu Beginn, wie würdest Du Dein Haar einschätzen?',
            component: 'MultipleChoice',
            type: 'radio',
            // type: 'checkbox',
            // name: 'entry.1313414293_sentinel',
            name: 'entry.1313414293',
            required: true,
            items: [
                {
                    label: 'Feines Haar',
                    value: 'Feines Haar',
                },
                {
                    label: 'Dickes Haar',
                    value: 'Dickes Haar',
                },
                {
                    label: 'Normales Haar',
                    value: 'Normales Haar',
                },
            ]
        },

        {
            title: 'Haarfarbe',
            description: 'Bunt, blond oder doch dunkel? Wie ist die Farbe Deiner Haare? :)',
            component: 'MultipleChoice',
            type: 'radio',
            name: 'entry.1533160103',
            items: [
                {
                    label: 'Blonde Strähnchen',
                    value: 'Blonde Strähnchen',
                },
                {
                    label: 'Blondiert',
                    value: 'Blondiert',
                },
                {
                    label: 'Andere Farbe',
                    value: 'Andere Farbe',
                },
                {
                    label: 'Natur',
                    value: 'Natur',
                },
            ]
        },

        {
            title: 'Haarstruktur',
            description: 'Unkontrollierbar lockig, oder vielleicht seidenglatt? Wie ist die Struktur Deiner Haare? ;)',
            component: 'MultipleChoice',
            type: 'radio',
            name: 'entry.1912355803',
            items: [
                {
                    label: 'Glatt',
                    value: 'Glatt',
                },
                {
                    label: 'Locken',
                    value: 'Locken',
                },
                {
                    label: 'Wellig',
                    value: 'Wellig',
                },
                {
                    label: 'Kraus',
                    value: 'Kraus',
                },
            ]
        },

        {
            title: 'Problemzonen',
            description: 'Wo liegen Deine Problemzonen?',
            component: 'MultipleChoice',
            type: 'checkbox',
            name: 'entry.1789234874',
            items: [
                {
                    label: 'Schnell fettiges Haar',
                    value: 'Schnell fettiges Haar',
                },
                {
                    label: 'Trockene Kopfhaut',
                    value: 'Trockene Kopfhaut',
                },
                {
                    label: 'Haarausfall',
                    value: 'Haarausfall',
                },
                {
                    label: 'Geschädigtes Haar/Trockene Längen/Spitzen',
                    value: 'Geschädigtes Haar/Trockene Längen/Spitzen',
                },
                {
                    label: 'Haare brechen ab',
                    value: 'Haare brechen ab',
                },
                {
                    label: 'Juckende Kopfhaut',
                    value: 'Juckende Kopfhaut',
                },
                {
                    label: 'Haare laden sich statisch auf',
                    value: 'Haare laden sich statisch auf',
                },
                {
                    label: 'Spliss/Frizz',
                    value: 'Spliss/Frizz',
                },
                {
                    label: 'Entzündete Kopfhaut',
                    value: 'Entzündete Kopfhaut',
                },

            ]
        },

        {
            title: 'Gesichtshaut',
            description: 'Wie ist Deine Gesichtshaut beschaffen?',
            component: 'MultipleChoice',
            type: 'radio',
            name: 'entry.146373112',
            items: [
                {
                    label: 'Normal',
                    value: 'Normal',
                },
                {
                    label: 'Trocken',
                    value: 'Trocken',
                },
                {
                    label: 'Fettig',
                    value: 'Fettig',
                },
                {
                    label: 'Mischhaut',
                    value: 'Mischhaut',
                },
            ]
        },

        {
            // title: 'Was wünscht Du Dir für Dein Haar?',
            title: 'Wünsche',
            description: 'Was kannst Du uns noch zu Deiner Wunsch-Routine sagen?',
            component: 'MultipleChoice',
            type: 'checkbox',
            name: 'entry.2080436613',
            items: [
                {
                    label: 'Mehr Volumen erwünscht',
                    value: 'Mehr Volumen erwünscht',
                },
                {
                    label: 'Hitzeschutz von Nöten',
                    value: 'Hitzeschutz von Nöten',
                },
                {
                    label: 'Tägliches Duschen durch Sport/Arbeit',
                    value: 'Tägliches Duschen durch Sport/Arbeit',
                },
                {
                    label: 'Kämmbarkeit verbessern',
                    value: 'Kämmbarkeit verbessern',
                },
                {
                    label: 'Gelbstich mindern / Blond auffrischen',
                    value: 'Gelbstich mindern / Blond auffrischen',
                },
                {
                    label: 'Farbintensität stärken',
                    value: 'Farbintensität stärken',
                },
                {
                    label: 'Styling Produkt erwünscht, aber Inspiration nötig',
                    value: 'Styling Produkt erwünscht, aber Inspiration nötig',
                },
                {
                    label: 'Trockenshampoo erwünscht',
                    value: 'Trockenshampoo erwünscht',
                },

            ]
        },

        {
            // title: 'Wohin sollen wir Deine Empfehlung schicken?',
            title: 'Empfehlung',
            description:
                `Wohin sollen wir Deine Empfehlung schicken?
<br><br>
Bitte achte darauf, dass Deine Email richtig geschrieben ist, denn nur so erhältst Du auch Deine gewünschte Empfehlung. Aufgrund der individuellen Bearbeitung kann die Zustellung Deiner Mail mehrere Stunden benötigen. 
<br><br>
Liebe Grüße
<br>
Dein Team von genuine haircare
`,
            component: 'ShortText',
            type: 'email',
            id: '1787720793',
            name: 'entry.1787720793',
            label: 'an meine Emailadresse:',
            placeholder: 'Emailadresse',
            required: true,
        },

        {
            title: 'Geschafft!',
            // description: 'Herzlichen Dank für Deine Zeit! Unser hilfsbereites Team kümmert sich nun um Deine Empfehlung! Auf bald und auf glückliche Haare! :)',
            description: `
            Herzlichen Dank für Deine Zeit! Unser hilfsbereites Team kümmert sich nun um Deine Empfehlung!
            <br><br>
            Abonniere unseren <a href="https://genuine-haircare.de/pages/newsletter" target="_blank" >Newsletter</a> und erhalte regelmäßig wertvolle Tipps, Wissen & Inspiration rund um Haarpflege & exklusive Aktionen.
            <br>
            Werde Teil unserer wundervollen genuine Community.
            <br><br>
            Auf bald und auf glückliche Haare! :)
            `
        },

    ]
} )

let inputs = reactive(

    !definition.dev

        ? [
            '',
            '',
            '',
            [],
            '',
            [],
            '',
        ]

        : [
            "Normales Haar",
            "Natur",
            "Kraus",
            [
                "Entzündete Kopfhaut"
            ],
            "Mischhaut",
            [
                "Trockenshampoo erwünscht"
            ],
            "yoda@zdv.io"
        ]

)



const form = reactive( {
    steps: definition.pages.length - 1,
    step: 0,
    done: false,
    data: Array( definition.pages.length - 2 ).fill( null ),
    // completed: computed( () => !form.data.includes( null ) ),
    completed: computed( () => !( inputs.includes( '' ) || inputs.includes( [] ) ) ),
} )


const checkStorage = () => {

    if( definition.dev ) console.log( 'checkStorage' )

    let __hta_inputs = null

    try {
        __hta_inputs = localStorage.getItem( "__hta_inputs" )
    } catch( err ) {
        console.error( err )
    }

    if( definition.dev ) console.log( __hta_inputs )

    if( __hta_inputs !== null ) {
        try {

            const __hta_inputs_parsed = JSON.parse( __hta_inputs )

            if( typeof __hta_inputs_parsed === 'object' && Array.isArray( __hta_inputs_parsed ) && __hta_inputs_parsed.length === 7 ) {
                inputs = reactive( __hta_inputs_parsed )
            } else {
                if( definition.dev ) console.warn( '__hta_inputs_parsed not an array' )
            }



        } catch( err ) {
            if( definition.dev ) console.warn( 'err @ JSON.parse( __hta_inputs ) // err:', err )
        }
    }

}

const saveToStorage = () => {

    if( definition.dev ) console.log( 'saveToStorage' )

    const __hta_inputs = inputs

    if( definition.dev ) console.log( __hta_inputs )


    try {

        const __hta_inputs_stringified = JSON.stringify( __hta_inputs )

        if( definition.dev ) console.log( __hta_inputs_stringified )

        localStorage.setItem( "__hta_inputs", __hta_inputs_stringified )


    } catch( err ) {
        if( definition.dev ) console.warn( 'err @ JSON.stringify( __hta_inputs ) // err:', err )
    }

}

const crossMessage = obj => {

    if( process.env.NODE_ENV !== 'production' ) return

    const target_origin = '*'//'https://genuine-haircare.de'

    if( definition.dev ) {
        console.log( 'crossMessage > obj:', obj )
        console.log( 'crossMessage > typeof window.parent:', typeof window.parent )
    }

    try {
        window.parent.postMessage( obj, target_origin )
    } catch( err ) {
        if( definition.dev ) console.warn( 'err @ crossMessage > window.parent.postMessage // err:', err )
    }



}

checkStorage()

export default function () {

    // onBeforeMount( () => {



    // } )



    return {
        definition, form, inputs, saveToStorage, crossMessage,
    }

}